import { render } from "./ShellInput.vue?vue&type=template&id=062d5f7c"
import script from "./ShellInput.vue?vue&type=script&lang=js"
export * from "./ShellInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__